import { getEffectiveDateValidationSchema } from 'modules/subassignmentManagement/components/EafFormShared/getEffectiveDateValidationSchema';
import { ValidationMessages } from 'shared/models/Validation';
import { IClientPaySettings } from 'store/entities/clients/clientsModel';
import * as yup from 'yup';

export const getCompensationChangeValidationSchema = (paySettings: IClientPaySettings, additionalDate?: string) => {
    return yup.object().shape({
        newPayRate: yup.number().nullable()
            .min(0, 'Pay rate should be more than 0')
            .required(ValidationMessages.REQUIRED),
        reason: yup.string().nullable().required(ValidationMessages.REQUIRED),
        effectiveDate: getEffectiveDateValidationSchema(paySettings, additionalDate),
    });
};
